import moment from 'moment';

class SupporterListHelper {
    static filter(supporters, searchString, statesFilter, periodsFilter) {
        let supporter;
        let foundSearchString, foundStatesFilter, foundPeriodsFilter, searchStringParts;
        for (let i = 0; i < supporters.length; i++) {
            supporter = supporters[i];
            foundSearchString = true;
            foundStatesFilter = true;
            foundPeriodsFilter = true;
            if(searchString.length > 0) {
                searchStringParts = searchString.split(" ");
                for(let j = 0; j < searchStringParts.length; j++) {
                    foundSearchString = foundSearchString &&  ((supporter.firstname && supporter.firstname.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1) || (supporter.lastname && supporter.lastname.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1) || (supporter.nickname && supporter.nickname.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1) || supporter.email.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1 || (supporter.bftToken !== null && supporter.bftToken === searchStringParts[j]) || (supporter.groupName !== null && supporter.groupName.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1));
                }
            }
            if(statesFilter.length > 0) {
                foundStatesFilter = (statesFilter.includes(supporter.state));
            }
            if(periodsFilter.length > 0) {
                foundPeriodsFilter = (periodsFilter.includes(supporter.period));
            }
            supporter.visible = (foundSearchString && foundStatesFilter && foundPeriodsFilter);
        }
        return supporters;
    }

    // not needed anymore
    static findAvailableStates(supporters) {
        let availableStates = [];
        for (let i = 0; i < supporters.length; i++) {
            availableStates.push(supporters[i].state);
        }
        return Array.from(new Set(availableStates));
    }

    static findAvailablePeriods(supporters) {
        let availablePeriods = [];
        let foundPeriodNames = [];
        for (let i = 0; i < supporters.length; i++) {
            if (supporters[i].period !== null && !foundPeriodNames.find((el) => {
                    return el === supporters[i].period
                })) {
                availablePeriods.push({
                    periodId: supporters[i].periodId,
                    period: supporters[i].period,
                    periodStartAt: supporters[i].periodStartAt,
                    periodEndAt: supporters[i].periodEndAt
                });
                foundPeriodNames.push(supporters[i].period);
            }
        }
        availablePeriods = availablePeriods.sort((a, b) => {
            return moment(a.periodStartAt).isAfter(moment(b.periodStartAt))
        });
        return Array.from(new Set(availablePeriods)).filter((el) => el.period !== null);
    }

    static findCurrentProject(projects) {
        return projects.find((project) => {
            return project.current === true
        })
    }
}

export default SupporterListHelper;
